import select2 from 'select2';
select2(window, $);

const SUBSITE_TYPE_ALL = 'all';
const SUBSITE_TYPE_SPECIFIC = 'specific';

const _SharedComponents = (function () {
    function setupEmailReportsField () {
        const elParent = $('.email-report-list');

        elParent.find('.email-report-item').each(function () {
            const elItem = $(this);

            elItem.find('.email-report-subsite-field:not(.select2-hidden-accessible)').select2({
                theme: "bootstrap-5",
                dropdownCssClass: 'searchable-select-dropdown',
                placeholder: "Subsite",
                tags: true,
                createTag: function (params) {
                    const value = params.term.trim();

                    // Reject if it starts with http:// or https://
                    if (value.startsWith('http://') || value.startsWith('https://')) {
                        return null;
                    }

                    // Validate domain format using a regex similar to FILTER_VALIDATE_DOMAIN
                    const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}(\/[a-zA-Z0-9-_/.]+)*$/;

                    if (domainRegex.test(value)) {
                        return {
                            id: value,
                            text: value
                        };
                    }

                    // Reject the input if it doesn't pass validation
                    return null;
                }
            });

            elItem.find('.email-report-users-field:not(.select2-hidden-accessible)').select2({
                theme: "bootstrap-5",
                dropdownCssClass: 'searchable-select-dropdown',
                placeholder: "Users",
                ajax: {
                    delay: 250,
                    method: 'POST',
                    url: elParent.data('users-query-url'),
                    data: function ( params ) {
                        const subsiteType = elItem.find('.email-report-subsite-type-field:checked').val();

                        return {
                            _token: $('[name="csrf-token"]').attr('content'),
                            term: params.term,
                            bot_id: elParent.data('bot-id'),
                            subsite_type: subsiteType,
                            subsite: subsiteType === SUBSITE_TYPE_SPECIFIC ? elItem.find('.email-report-subsite-field').val() : null,
                        };
                    },
                    processResults: function ( data, params ) {
                        return {
                            results: data.map(item => ({
                                id: item.id,
                                text: `${item.name} (${item.email})`
                            }))
                        };
                    }
                }
            });
        });
    }

    function setupEmailReportSetting () {
        $('body')
            .on('change', '.email-report-list .email-report-item .email-report-subsite-field', function () {
                const elEmailReportItem = $(this).closest('.email-report-item');
                const elParent =  $(this).closest('.email-report-list');
                const select2Field = elEmailReportItem.find('.email-report-users-field');

                // Store currently selected IDs
                const previouslySelectedIds = select2Field.val() || [];

                // Force a reload of options
                $.ajax({
                    method: 'POST',
                    url: elParent.data('users-query-url'),
                    data: {
                        _token: $('[name="csrf-token"]').attr('content'),
                        term: '', // optionally pass empty term for initial load
                        bot_id: elParent.data('bot-id'),
                        subsite_type: elEmailReportItem.find('.email-report-subsite-type-field:checked').val(),
                        subsite: elEmailReportItem.find('.email-report-subsite-field').val(),
                    },
                    success: function (data) {
                        const validOptionIds = data.map(item => item.id.toString());

                        // Filter previous selections to keep only valid ones
                        const stillValidSelections = previouslySelectedIds.filter(id =>
                            validOptionIds.includes(id.toString())
                        );

                        // Manually clear and update Select2 options
                        select2Field.empty();

                        // Re-add options
                        data.forEach(item => {
                            const option = new Option(
                                `${item.name} (${item.email})`,
                                item.id,
                                false,
                                stillValidSelections.includes(item.id.toString())
                            );
                            select2Field.append(option);
                        });

                        // Trigger change to update UI
                        select2Field.trigger('change');
                    }
                });
            })
            .on('change', '.email-report-item .subsites-holder .email-report-subsite-type-field-holder .form-check-input', function () {
                const el = $(this),
                    elParent = el.closest('.subsites-holder');
                elParent.find('.email-report-subsite-field-holder').toggleClass('d-none', el.val() === SUBSITE_TYPE_ALL);
                elParent.find('.email-report-attach-report-scope-field-holder ').toggleClass('d-none', el.val() === SUBSITE_TYPE_SPECIFIC);
                elParent.find('.email-report-subsite-field').trigger('change');
            });

        $('#email_reports_settings').on('click', '.add-link', function () {
            let parent = $(this).closest('.email-reports-wrapper'),
                tpl = $('#email_report_item_tpl').clone(),
                lastIndex = parent.find('.email-report-item:last-child').data('index'),
                index = isNaN(lastIndex)? 0 : parseInt(lastIndex) + 1;

            tpl.find('.email-report-item').attr('data-index', index).data('index', index);
            tpl.find('.email-report-frequency-field').attr('name', 'email_reports_setting[email_reports][' + index + '][report_frequency]');
            tpl.find('.email-report-attach-report-scope-field').attr('name', 'email_reports_setting[email_reports][' + index + '][attach_report_scope]');
            tpl.find('.email-report-subsite-type-field').attr('name', 'email_reports_setting[email_reports][' + index + '][subsite_type]');
            tpl.find('.email-report-subsite-field').attr('name', 'email_reports_setting[email_reports][' + index + '][subsite]');
            tpl.find('.email-report-users-field').attr('name', 'email_reports_setting[email_reports][' + index + '][users][]');

            tpl.find('.email-report-subsite-type-all-field').attr('id', 'email_reports_subsite_type_all_' + index).closest('.form-check').find('.form-check-label').attr('for', 'email_reports_subsite_type_all_' + index);
            tpl.find('.email-report-subsite-type-specific-field').attr('id', 'email_reports_subsite_type_specific_' + index).closest('.form-check').find('.form-check-label').attr('for', 'email_reports_subsite_type_specific_' + index);
            tpl.find('.email-report-attach-report-scope-field').attr('id', 'email_reports_attach_report_scope_' + index).closest('.form-check').find('.form-check-label').attr('for', 'email_reports_attach_report_scope_' + index);

            parent.find('.email-report-list').append(tpl.html());
            setupEmailReportsField();
        }).on('click', '.remove-link', function () {
            $(this).closest('.email-report-item').remove();
        });

        setupEmailReportsField();
    }

    function setupDropdownTypeHead() {
        $('.typehead-select-dropdown').select2({
            theme: "bootstrap-5",
            dropdownCssClass: 'searchable-select-dropdown'
        });
    }

    function init() {
        setupEmailReportSetting();
        setupDropdownTypeHead();
    }

    return {
        init: init
    };
})()


$(function () {
    _SharedComponents.init();
});

export default _SharedComponents;
